export const POPULAR_ACTIVITY_IDS = ['12', '16', '11', '9', '21', '24']

export const POPULAR_ACTIVITY_IDS_BY_SITE = {

  'fitness': [
    '16', // run
    '11', // bike ride
    '9', // walk
    '24', // hike
    '12', // gym workout
    '21', // sport / other
  ],

  'run': [
    '16', // run
    '9', // walk
    '24', // hike
    '11', // bike ride
    '12', // gym workout
    '21', // sport / other
  ],

  'ride': [
    '11', // bike ride
    '16', // run
    '9', // walk
    '24', // hike
    '12', // gym workout
    '21', // sport / other
  ],

  'walk': [
    '9', // walk
    '24', // hike
    '16', // run
    '11', // bike ride
    '12', // gym workout
    '21', // sport / other
  ],

  'hike': [
    '24', // hike
    '9', // walk
    '16', // run
    '11', // bike ride
    '12', // gym workout
    '21', // sport / other
  ],

}

export const FETCH_ACTIVITY_TYPES = 'FETCH_ACTIVITY_TYPES'
export const FETCH_ACTIVITY_TYPES_LOADING = 'FETCH_ACTIVITY_TYPES_LOADING'
export const FETCH_ACTIVITY_TYPES_ERROR = 'FETCH_ACTIVITY_TYPES_ERROR'
export const FETCH_ACTIVITY_TYPES_SUCCESS = 'FETCH_ACTIVITY_TYPES_SUCCESS'

